import React, { ReactNode, useContext, useState } from 'react'
import { PaymentMethod } from 'types/payment'
import {
    AppointmentContext,
    AppointmentProvider,
} from './AppointmentPurchaseContext'
import {
    IAppointmentPurchase,
    initialState,
} from './AppointmentPurchaseType'

function AppointmentPurchaseContainer({ children }: any) {
    const [state, setState] = useState(initialState)

    const [isValidCoupon, setIsValidCoupon] = useState(false)
    const [lockForm, setLockForm] = useState(true)
    const [couponCode, setCouponCode] = useState('')
    const [totalPrice, setTotalPrice] = useState(0)
    const [isCardWithCouponEnabled, setIsCardWithCouponEnabled] =
        useState(false)
    const [paymentMethod, setPaymentMethod] = useState(
        PaymentMethod.MEMBER as string
    )
    const [couponInfo, setCouponInfo] = useState(undefined)
    const [isValidMembership, setIsValidMembership] = useState(false)

    const resetContext = () => {
        setCouponCode(''), setLockForm(true)
        setCouponInfo(undefined)
        setCouponCode('')
        setIsCardWithCouponEnabled(false)
        setPaymentMethod(PaymentMethod.MEMBER as string)
        setTotalPrice(0)
        setIsValidCoupon(false)
    }

    const value: IAppointmentPurchase = {
        isValidCoupon,
        setIsValidCoupon,
        lockForm,
        setLockForm,
        paymentMethod,
        setPaymentMethod,
        couponInfo,
        setCouponInfo,
        couponCode,
        setCouponCode,
        totalPrice,
        setTotalPrice,
        isCardWithCouponEnabled,
        setIsCardWithCouponEnabled,
        resetContext,
        isValidMembership,
        setIsValidMembership,
    }
    return (
        <AppointmentProvider value={value}>{children}</AppointmentProvider>
    )
}

export default AppointmentPurchaseContainer

export const useAppointmentContext = () => useContext(AppointmentContext)
